import { PERSONAL_WORKSPACE_SELECTION } from "../../constants/organization/organizationWorkspace";
import { IMyOrganizationEntry } from "../../types/organization/IMyOrganizationEntry";
import { OrganizationStatusEnum } from "../../types/organization/OrganizationStatusEnum";

/**
 * Picks the organization the dashboard treats as active.
 *
 * A stored organization the user still belongs to wins; a stored personal
 * choice means no organization. Otherwise the first ACTIVE membership is
 * chosen, then any membership, so a new browser lands on the user's
 * organization rather than an empty personal workspace.
 *
 * @param storedSelection - Persisted selection: an organization id, the personal-workspace value, or null.
 * @param memberships - Organizations the user belongs to.
 * @returns The active organization id, or null for the personal workspace.
 */
export function resolveActiveOrganizationId(
  storedSelection: string | null,
  memberships: IMyOrganizationEntry[]
): string | null {
  if (storedSelection === PERSONAL_WORKSPACE_SELECTION) {
    return null;
  }
  if (storedSelection && memberships.some((membership) => membership.organization.id === storedSelection)) {
    return storedSelection;
  }
  const firstActiveMembership = memberships.find(
    (membership) => membership.organization.status === OrganizationStatusEnum.ACTIVE
  );
  return (firstActiveMembership ?? memberships[0])?.organization.id ?? null;
}
